import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 23 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0.5 18V6H2.5V8H4.5V0H6.5V2H8.5V0H10.5V2H12.5V0H14.5V2H16.5V0H18.5V8H20.5V6H22.5V18H13.5V15C13.5 14.45 13.3042 13.9792 12.9125 13.5875C12.5208 13.1958 12.05 13 11.5 13C10.95 13 10.4792 13.1958 10.0875 13.5875C9.69583 13.9792 9.5 14.45 9.5 15V18H0.5ZM2.5 16H7.5V15C7.5 13.9 7.89167 12.9583 8.675 12.175C9.45833 11.3917 10.4 11 11.5 11C12.6 11 13.5417 11.3917 14.325 12.175C15.1083 12.9583 15.5 13.9 15.5 15V16H20.5V10H16.5V4H6.5V10H2.5V16ZM8.5 9H10.5V6H8.5V9ZM12.5 9H14.5V6H12.5V9Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }